import routes from './routes'

export default {
  account: {
    changePasswordSuccessMessage: 'Su contraseña se ha cambiado correctamente',
    noOrders: 'Aún no has realizado un pedido. Haz tu primera compra ',
    here: 'aqui.',
    noCreditCards: 'No tienes tarjetas de crédito guardadas',
    noAddressSaved: 'Ninguna dirección guardada',
    deleteAccount: 'Borrar cuenta',
    error: {
      password: 'Error introduce una contraseña',
      passwordRegister:
        'Introduce una contraseña de más de {{length}} carácteres',
      passwordRegisterRepeat: 'Debe coincidir con la nueva contraseña'
    },
    changePasswordButton: 'Cambiar Contraseña',
    oldPassword: 'Contraseña actual',
    privacyTab: {
      title: 'Privacidad',
      subtitle:
        'En Damm queremos proteger tu privacidad y usar bien tus datos. Por eso, puedes gestionar tus preferencias aquí:',
      changePasswordTitle: 'Cambiar contraseña',
      deleteAccountTitle: 'Eliminar cuenta',
      deleteAccountMessage:
        'Confirmo que quiero darme de baja de la base de datos de Damm.com y no volver a recibir ningún mensaje promocional.',
      dialog: {
        title: 'Eliminar cuenta',
        description: '¿Estás seguro que quieres borrar tu cuenta?',
        goBack: 'Atras',
        deleteAccount: 'Borrar'
      }
    },
    newPassword: 'Nueva contraseña',
    newPasswordRepeat: 'Repite contraseña',
    newsletterSubscription: 'Comunicaciones',
    personalTab: {
      addAddress: 'Añadir dirección',
      editAddress: 'Editar dirección',
      save: 'Guardar',
      cancel: 'Cancelar',
      editPersonalDataForm: {
        firstName: 'Nombre',
        lastName: 'Apellidos',
        email: 'Email',
        postalcode: 'Código Postal',
        sex: 'Sexo',
        male: 'Hombre',
        female: 'Mujer'
      },
      title: 'Mis Datos',
      personalDataTitle: 'Datos personales',
      myAddresses: 'Mis direcciones',
      addNewAddress: '+ Añadir nueva dirección',
      saveEditPersonalDataButton: 'Guardar',
      cancelOrder: 'Cancelar',
      myCards: 'Mis tarjetas',
      logout: 'Cerrar sesión',
      expires: 'Caduca',
      dialog: {
        title: 'Borrar Dirección',
        description:
          '¿Estás seguro que deseas eliminar dirección? Esta acción no se puede deshacer.',
        maintainAddress: 'Mantener Dirección',
        deleteAddress: 'Borrar Dirección'
      }
    },
    ordersTab: {
      title: 'Mis Pedidos',
      noOrders: 'No tienes ningun pedido',
      orderID: 'Pedido Nº:',
      cancelOrder: 'Cancelar pedido',
      orderDetail: {
        totalProducts: 'Total de productos:',
        orderID: 'Nº de pedido:',
        dateOfPurchase: 'Fecha de compra:',
        status: 'Estado',
        address: 'Dirección:',
        total: 'Total:',
        shippingFee: 'Gastos de envío:',
        return: 'Devolver compra',
        downloadInvoice: 'Descargar factura'
      },
      status: {
        title: 'Estado:',
        open: 'Abierto',
        preparing: 'En preparacíon',
        inDelivery: 'En reparto',
        withIncidence: 'Con incidencía',
        delivered: 'Entregado',
        canceled: 'Cancelado',
        unknown: 'Desconocido'
      },
      dialog: {
        title: 'Cancelar Pedido',
        confirmationTitle: 'Compra cancelada',
        description: '¿Estás seguro de que quieres devolver la compra?',
        noCancelOrder: 'Cancelar',
        cancelOrder: 'Aceptar',
        confirmationDescription:
          'Tu compra ha sido cancelada. Te llamaremos para confirmar la cancelacíon.',
        understood: 'Entendido'
      }
    }
  },
  auth: {
    createAccount: 'Crear cuenta',
    change: 'Cambiar',
    dataUsage: 'Acepto la cesión de mis datos personales a',
    dataUsageTo: 'para recibir comunicaciones comerciales',
    enter: 'Acceder',
    forgotPassword: '¿Has olvidado tu contraseña?',
    login: 'Acceder',
    legalNotice: 'Aviso legal',
    loginUlabox: 'Accede a tu cuenta',
    newPassword: 'Nueva contraseña',
    newPasswordText:
      'Introduce la nueva contraseña para tu cuenta. Este enlace es temporal y puede usarse solamente una vez. Introduce una contraseña que tenga como mínimo 8 caracteres. Te recomendamos que uses mayúsculas, minúsculas, números, incluso ¡jeroglíficos egipcios! Bueno, vale, esto último no. Pero, ya sabes, ponlo difícil. ;-)',
    personalData:
      'Acepto que Damm use mis datos personales con la finalidad de recibir promociones exclusivas, las últimas novedades e información personalizada adaptada a mi perfil.',
    personalDataLink: 'protección de datos personales de S.A DAMM.',
    personalDataAccept:
      'Acepto que Damm use mis datos personales con la finalidad de recibir promociones exclusivas, las últimas novedades e información personalizada adaptada a mi perfil.',
    privacyDestinataries: 'Destinatarios: S.A. DAMM y la empresa ULABOX SL',
    privacyInfo: 'Información adicional: ',
    privacyLegitimation: 'Legitimación: Consentimiento del interesado',
    privacyPolicy: 'Politica de privacidad',
    privacyReason:
      'Finalidad: Gestión de los pedidos realizados a través de esta web; envío de información, publicidad y promoción comercial de productos, servicios y actividades de su interés en el ámbito del sector de la alimentación y bebidas; análisis de perfil para buscar contenidos que sean de su interés, utilizando técnicas de profiling para realizar publicidad dirigida y marketing directo.',
    privacyRights:
      'Derechos: Acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información adicional.',
    privacyTitle: 'Inf. básica de protección de datos',
    recover: 'Recuperar',
    recoverPassword: 'Recuperar contraseña',
    recoverPasswordSuccess: 'Tu contraseña se ha cambiado correctamente.',
    register: 'Registrate',
    registerUlabox: 'Crea una cuenta',
    registerDammPrivacyPolicy:
      'https://static.ulabox.com/media/merchant/damm/doc/damm_privacy_policy_es.pdf',
    termsAndCons:
      'He leído y acepto la información sobre protección de datos personales de S.A. DAMM.',
    verifying: 'Estamos verificando tu cuenta',
    welcome: 'Bienvenido a Damm',
    label: {
      email: 'Email',
      password: 'Contraseña',
      postalcode: 'Código postal'
    },
    error: {
      email: 'Error debes introducir un email válido',
      password: 'Error introduce una contraseña',
      postalcode: 'Error debes introducir un código postal',
      termsAndCons: 'Error debes aceptar los términos y condiciones',
      passwordRegister:
        'Introduce una contraseña de más de {{length}} carácteres'
    }
  },
  checkout: {
    invoiceForm: {
      name: 'Nombre: ',
      companyName: 'Nombre de la empresa: ',
      address: 'Dirección: '
    },
    banner: '¡Espera! ¿Seguro que no te dejas nada?',
    firstStep: '1 Carrito',
    secondStep: '2 Envío',
    thirdStep: '3 Pago',
    cartSummary: 'Resumen del carrito',
    totalShipping: 'Gastos de envío',
    totalOrder: 'Total pedido',
    totalProducts: 'Total productos',
    totalDiscounts: 'Total descuentos',
    expectedDelivery: 'Entrega prevista',
    paymentMethod: 'Método de pago',
    addCard: 'Añadir tarjeta',
    cart: 'Carrito',
    add: 'Añadir',
    nextStepPayment: 'Siguiente: Pago',
    nextStepDelivery: 'Siguiente: Envío',
    processingStep: 'Tramitando...',
    addAnotherDeliveryAddress: 'Añadir dirección de entrega',
    selectDeliveryAddress: 'Selecciona dirección de entrega',
    selectDeliveryAddressInput: 'Elige una dirección de entrega',
    deliveryDate: 'Fecha de entrega',
    deliveryEstimated:
      '{{name}}: A partir de mañana hasta el {{day}} día {{dayDate}} de {{month}} incluído',
    deliveryPrevision:
      'A partir de mañana hasta el {{day}} día {{dayDate}} {{month}}',
    addAddress: 'Añadir dirección',
    makePayment: 'Realizar pago',
    processingPayment: 'Procesando pago...',
    total: 'Total',
    thanks: '¡Gracias!',
    thanksMessage: 'Tu pago se ha realizado correctamente',
    orderSummary: 'Resumen de tu compra',
    deliveryAddress: 'Dirección de envío',
    thanksDeliveryEstimated:
      'Recibirás tu compra antes del {{day}} día {{dayDate}} de {{month}}',
    error: {
      addressSelect: 'Debes seleccionar una dirección',
      nameSurname: 'Debes introducir tu nombre y apellidos',
      street: 'Debes introducir una calle',
      number: 'Debes introducir un número',
      lift: 'Debes seleccionar una opción',
      postalCode: 'Debes introducir un código postal',
      city: 'Debes introducir una ciudad',
      phone: 'Debes introducir un número de teléfono',
      alias: 'Debes introducir un alias',
      personType: 'Debes seleccionar una opción',
      invoiceName: 'Debes introducir tu nombre',
      invoiceFirstSurname: 'Debes introducir tu apellido',
      invoiceEmail: 'Debes introducir tu email',
      invoiceNIF: 'Debes introducir un NIF válido',
      invoiceCIF: 'Debes introducir un CIF válido',
      invoiceCompany: 'Debes introducir la razón social',
      holder: 'Debes introducir el nombre del titular',
      cardNumber: 'Debes introducir un número de tarjeta válido',
      cardExpirationMonth: 'Debes introducir un mes de expiración',
      cardExpirationYear: 'Debes introducir un año de expiración',
      cardCVV: 'Debes introducir un CVV',
      selectCreditCard: 'Debes seleccionar una tarjeta de crédito'
    },
    label: {
      name: 'Nombre',
      city: 'Ciudad',
      street: 'Calle',
      number: 'Número',
      postalCode: 'Código postal',
      phone: 'Teléfono',
      nameSurname: 'Nombre y apellidos',
      details: 'Piso, puerta, escalera',
      lift: '¿Tienes ascensor?',
      alias: 'Nombre de la dirección',
      includeBilling: '¿Incluir datos de facturación?',
      personType: 'Tipo de persona',
      personTypeLegal: 'Empresa',
      personTypeNatural: 'Particular/Autónomo',
      invoiceName: 'Nombre',
      invoiceFirstSurname: 'Primer apellido',
      invoiceSecondSurname: 'Segundo apellido',
      invoiceEmail: 'Email',
      invoiceNIF: 'NIF',
      invoiceCIF: 'CIF',
      invoiceCompany: 'Razón social',
      holder: 'Nombre del titular',
      cardNumber: 'Número de tarjeta',
      cardExpirationMonth: 'Mes',
      cardExpirationYear: 'Año',
      cardCVV: 'CVV',
      saveForFuture: '¿Guardar para futuras compras?',
      selectCreditCard: 'Selecciona tarjeta de crédito',
      addNewCreditCard: 'Pagar con nueva tarjeta'
    },
    goBack: 'Envio',
    edit: 'Editar'
  },
  product: {
    quantity: 'Cantidad*',
    pricePerUnit: 'Precio',
    add: 'Añadir',
    deliveryCostMessage: 'Gastos de envío gratis para todas tus compras.',
    maxUnitsPurchase: '*Pedido máximo 12 unidades',
    description: 'Descripción de producto',
    clickToZoom: 'Pulsar para ampliar la imagen',
    soldOut: '¡Ya no quedan, la próxima vez intenta ser más rápido!',
    catalan: 'Catalán',
    spanish: 'Español',
    productAvailableIn: 'Producto disponible en:',
    completePurchase: 'Completa tu compra'
  },
  appshell: {
    login: 'Iniciar sesión',
    myAccount: 'Mi cuenta',
    seo: {
      title: 'Shop Damm | Cervezas Damm',
      description:
        'Bienvenidos a la shop de Damm. Descubre y compra las últimas novedades cerveceras. Gastos de envío gratis por compras superiores a 29€.'
    },
    footer: {
      company: 'Compañía',
      contact: 'Contacto',
      legalNotice: 'Aviso legal',
      privacyPolicy: 'Política de privacidad',
      termsAndCons: 'Términos y condiciones',
      cookiesPolicy: 'Política de cookies',
      socialPolicy: 'Política de redes sociales',
      copyright: '© S.A. Damm',
      onlineSupermarket: ', el supermercado online',
      linksOfInterest: 'Enlaces de Interés',
      legal: 'Legal',
      seeEverything: 'Ver todo',
      customerService: 'Atención al cliente '
    },
    links: {
      legalWarning: '/es/static/merchant-legal-warning',
      privacyPolicy: '/es/static/merchant-privacy-policy',
      termsAndCons: '/es/static/terms-and-conditions',
      cookiesPolicy:
        'https://www.damm.com/es/politica-cookies?accessgranted=yes',
      socialPolicy:
        'https://www.damm.com/es/politica-redes-sociales?accessgranted=yes',
      company: 'https://www.dammcorporate.com/es?accessgranted=yes',
      contact: `https://www.damm.com/es/faqs?accessgranted=yes#form-contact-did-you-know`
    }
  },
  home: {
    viewDetails: 'Ver Detalles',
    buy: 'Comprar',
    viewDetailLinks: {
      complot: 'https://www.damm.com/es/cervezas/complot?accessgranted=yes'
    },
    freeDeliveryMessage: 'Envíos gratuitos para compras superiores a 29 €. Entrega en 2-3 días laborables en península.'
  },
  catalog: {
    viewDetails: 'Ver Detalles',
    buy: 'Comprar',
    view: 'Vista',
    type: {
      beer: 'Cervezas',
      specialPacks: 'New Now',
      glassware: 'Cristalería',
      merchandising: 'Merchandising'
    },
    seeEverything: {
      beer: 'Ver todo',
      specialPacks: 'Ver todo',
      glassware: 'Ver todo',
      all: 'Ver todo'
    },
    beer: {
      estrellaDamm: 'Estrella Damm',
      complotIPA: 'Complot IPA',
      malquerida: 'Malquerida',
      daura: 'Daura',
      dauraMarzen: 'Daura Marzen'
    },
    specialPacks: {},
    glassware: {
      estrellaDammCup: 'Copa Estrella Damm',
      volldammCup: 'Copa Voll-Damm',
      malqueridaCup: 'Copa Malquerida',
      flautaAKdamm: 'Copa A.K.Damm',
      ineditGlass: 'Vaso Inedit',
      complotGlass: 'Vaso Complot',
      gastronomicEstrellaDammGlass: 'Vaso Estrella Damm',
      estrelladammBigMug: 'Jarra Estrella Damm',
      bockdammMug: 'Jarra Bock-Damm',
      dammlemonMug: 'Jarra Damm Lemon'
    }
  },
  static: {
    error404: {
      goBack: 'Volver'
    },
    deprecated: {
      title: 'Parece que estás usando un navegador no compatible',
      message:
        'Para una mejor experiencia te recomendamos que utilices Google Chrome, Firefox o Safari.',
      downloadChrome: 'Descargar Chrome',
      downloadFirefox: 'Descargar Firefox',
      downloadSafari: 'Descargar Safari'
    },
    legalAgeCheck: {
      title: 'Nos encanta verte por aquí.',
      subtitle: '¿Eres mayor de edad?',
      yes: 'Sí',
      no: 'No',
      cookiesTitle: 'Aviso de Cookies.',
      cookiesText:
        'Utilizamos cookies propias y de terceros para mejorar nuestros servicios y mostrarte contenidos relacionados con tus preferencias mediante el análisis de tus hábitos de navegación. Si continúas navegando, consideramos que aceptas su uso. Puedes obtener más información en nuestra <0>Política de Cookies</0>.'
    }
  },
  snackbar: {
    accountVerification: '¡Cuenta activada correctamente!',
    accountRegister: 'Te hemos enviado un email para que verifiques tu cuenta.',
    accountRecover: 'Revisa el email para recuperar la contraseña'
  },
  buyButton: 'Comprar',
  cookiesMessage: {
    title: 'Aviso de Cookies',
    message:
      ' Utilizamos cookies propias y de terceros para mejorar nuestros servicios y mostrarte contenidos relacionados con tus preferencias mediante el análisis de tus hábitos de navegación. Si continúas navegando, consideramos que aceptas su uso. Puedes obtener más información en nuestra ',
    link: 'Política de Cookies',
    accept: 'Aceptar'
  },
  contactInfo: {
    message: 'Atención al cliente',
    phoneNumber: '900 373 183'
  },
  hardCoded: {
    catalog: {
      title: {
        estrellaDamm: 'Estrella Damm (Caja 12 x 25cl)',
        complotIPA: 'Complot IPA (Unidad)',
        complotIPABottle: 'Complot IPA (Unidad)',
        malquerida: 'Malquerida (Cesta 6 x 25cl)',
        daura: 'Daura (Cesta 6 x 33cl)',
        dauraMarzen: 'Daura Märzen (Cesta 6 x 33cl)',
        AKDammCup: 'Copa tipo flauta A.K.Damm 33cl (6 u.)',
        bockdammMug: 'Jarra Bock-Damm 33cl (6 u.)',
        complotGlass: 'Vaso Complot IPA 33cl (6 u.)',
        estrellaDammGlass: 'Vaso gastronómico Estrella Damm 33cl (6 u.)',
        dammlemonMug: 'Jarra Damm Lemon 40cl (6 u.)',
        estrellaDammCup: 'Copa Estrella Damm 33cl (6 u.)',
        estrellaDammMug: 'Jarra Estrella Damm 50cl (6 u.)',
        ineditGlass: 'Vaso Inedit 33cl (6 u.)',
        malqueridaCup: 'Copa Malquerida 33cl (6 u.)',
        volldammCup: 'Copa Voll-Damm 33cl (6 u.)',
        freeDammCero: 'Free Damm (Pack 6 x 25cl)',
        freeDammLimon: 'Free Damm Limón (Pack 6 x 25cl)',
        freeDammTostada: 'Free Damm Tostada (Pack 6 x 33cl)',
        freeDammTostadaBottle: 'Free Damm Tostada (Pack 6 x 33cl)',
        inedit: 'Inedit (Cesta 6 x 33cl)',
        vollDamm: 'Voll-Damm (Cesta 6 x 33cl)'
      }
    },
    productID: {
      estrellaDamm: 53690,
      complotIPA: 48725,
      complotIPABottle: 57742,
      malquerida: 53167,
      daura: 53168,
      dauraMarzen: 53169,
      AKDammCup: 53157,
      bockdammMug: 53154,
      estrellaDammGlass: 53155,
      complotGlass: 53159,
      dammlemonMug: 53615,
      estrellaDammCup: 53161,
      estrellaDammMug: 53160,
      ineditGlass: 53152,
      malqueridaCup: 53158,
      volldammCup: 53153,
      freeDammCero: 57741,
      freeDammLimon: 57740,
      freeDammTostada: 80215,
      freeDammTostadaBottle: 80170,
      inedit: 84372,
      vollDamm: 84373
    },
    title: {
      estrellaDammCup: 'Copa Estrella Damm',
      volldammCup: 'Copa Voll-Damm',
      malqueridaCup: 'Copa Malquerida',
      flautaAKdamm: 'Copa A.K.Damm',
      ineditGlass: 'Vaso Inedit',
      complotGlass: 'Vaso Complot',
      gastronomicEstrellaDammGlass: 'Vaso Estrella Damm',
      estrelladammBigMug: 'Jarra Estrella Damm',
      bockdammMug: 'Jarra Bock-Damm',
      dammlemonMug: 'Jarra Damm Lemon',
      estrellaDamm: 'Estrella Damm',
      complotIPA: 'Complot IPA',
      complotIPABottle: 'Complot IPA',
      malquerida: 'Malquerida',
      daura: 'Daura',
      dauraMarzen: 'Daura Marzen',
      freeDammCero: 'Free Damm',
      freeDammLimon: 'Free Damm Limón',
      freeDammTostada: 'Free Damm Tostada',
      freeDammTostadaBottle: 'Free Damm Tostada',
      inedit: 'Inedit',
      vollDamm: 'Voll-Damm'
    },
    slug: {
      53154: 'jarra-bock-damm',
      53159: 'vaso-complot',
      48725: 'complot-ipa',
      57742: 'complot-ipa',
      53615: 'jarra-damm-lemon',
      53168: 'daura',
      53169: 'daura-marzen',
      53690: 'estrella-damm',
      53545: 'copa-estrella-damm',
      53160: 'jarra-estrella-damm',
      53157: 'copa-a-k-damm',
      53544: 'vaso-estrella-damm',
      53152: 'vaso-inedit',
      53167: 'malquerida',
      53158: 'copa-malquerida',
      53153: 'copa-voll-damm',
      57741: 'free-damm',
      57740: 'free-damm-limon',
      80215: 'pack-free-damm-tostada',
      80170: 'free-damm-tostada',
      84372: 'cervezainedit',
      84373: 'cervezavolldamm',
      inedit: 'cervezainedit',
      vollDamm: 'cervezavolldamm'
    },
    format: {
      pack6: 'Cesta (6 x 33cl)',
      box12x66: 'Caja (12 x 66cl)',
      bottle: 'Botella (1 x 33cl)',
      bottle66: 'Botella (1 x 66cl)',
      canPack: 'Pack (6 x 33cl)',
      can: 'Unidad (1 x 33cl)'
    }
  },
  routes: routes['es']
}
